<template>
  <!--
// A -> xzs
// D -> 2020.04.15
// F -> 二次封装elementui table组件
// Object.assign() -> 源对象的所有可枚举属性-浅拷贝
 -->
  <div>
    <el-table
      ref="upTable"
      :data="data"
      v-bind="$attrs"
      :show-header="showHeader"
      :border="borderShow"
      :row-class-name="isVisited ? tableRowClassName : ''"
      @selection-change="handleSelectionChange"
    >
      <template v-for="(column, index) of columns">
        <!-- render -->
        <el-table-column
          v-if="column.render"
          v-bind="Object.assign({}, column)"
          :key="index"
        >
          <template slot-scope="scope">
            <extend :render="column.render" :params="scope"></extend>
          </template>
        </el-table-column>
        <!-- no render -->
        <el-table-column
          v-else
          v-bind="Object.assign({}, column)"
          :key="index"
        ></el-table-column>
      </template>
    </el-table>
    <div class="comtable-compage" :page="page">
      <p>
        共 {{ page.total }} 条记录 第 {{ page.current_page }} /
        {{ page.last_page }} 页
      </p>
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.current_page"
        :page-size="page.per_page"
        :total="page.total"
        prev-text="<上一页"
        next-text="下一页>"
        @current-change="tablePageChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import extend from "@/assets/js/renderProps.js";
export default {
  components: { extend },
  data() {
    return {
      borderShow: false
    };
  },
  props: {
    data: {
      type: Array
    },
    showHeader: {
      type: Boolean
    },
    columns: {
      type: Array
    },
    page: {
      type: Object,
      default: () => ({})
    },
    border: {
      type: Boolean
    },
    isVisited: {
      type: Boolean
    }
  },
  created() {},
  methods: {
    //分页触发，，绑定的父级方法
    handleSelectionChange(val) {
      let id_list = [];
      val.map(item => {
        id_list.push(item.cv_log_id);
      });
      this.$emit("putDownID", id_list);
    },
    tablePageChange(events) {
      this.$emit("pageChange", events);
    },
    tableRowClassName({ row, rowIndex }) {
      let visited_row =
        sessionStorage.getItem("historyjob" + row.created_at) || false;
      if (row.process_status == "已标记为不合适") {
        return "bgColor-row";
      } else if (!visited_row) {
        return "visited_background";
      }
    }
  }
};
</script>
<style scoped>
/* 头像 */
.table-head {
  width: 36px;
  height: 36px;
  border-radius: 18px;
}

/* page */
.comtable-compage {
  width: 100%;
  padding: 40px 0 80px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
}

.comtable-compage p {
  display: inline-block;
  height: 46px;
  line-height: 46px;
  font-size: 12px;
  color: #888;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
<style>
/* 标记为不合适行半透明 */
.el-table .bgColor-row {
  opacity: 0.5;
}
/* 列表点击浏览后 */
.el-table .visited_background {
  /* color: #0077FF; */
}
/* 分页样式 */
.comtable-compage .el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  height: 36px !important;
  line-height: 36px !important;
  padding: 0 7px !important;
}
.el-pager li.active + li {
  border: 1px solid #eaeaea !important;
}
.el-pager li {
  padding: 0 14px !important;
  height: 36px !important;
  line-height: 36px !important;
  margin: 0 10px !important;
}
.el-pagination .btn-next,
.el-pagination .btn-prev,
.el-pagination .el-pager li {
  background-color: #fff !important;
  border-radius: 2px !important;
  border: 1px solid #eaeaea !important;
  color: #555 !important;
}
.el-pagination .el-pager li:not(.disabled).active {
  background-color: #fff !important;
  border-radius: 2px !important;
  border: 1px solid #0077ff !important;
  color: #0077ff !important;
}
/* 去详情按钮 */
.table-btn-disable {
  border: none;
  font-size: 12px;
  color: #dddddd;
  background: rgba(0, 0, 0, 0);
  outline: none;
  cursor: not-allowed;
}
.table-btn-show {
  border: none;
  font-size: 12px;
  color: #ff7247;
  background: rgba(0, 0, 0, 0);
  outline: none;
}
.table-btn {
  border: none;
  font-size: 12px;
  color: #0077ff;
  background: rgba(0, 0, 0, 0);
  outline: none;
  cursor: pointer;
}

.table-btn:hover {
  color: rgb(61, 150, 252);
}
</style>



// WEBPACK FOOTER //
// src/components/TablePage.vue